/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
import currency from "currency.js";
import { TFunction } from "i18next";
import { useMemo } from "react";
import { useTable } from "react-table";
import { SideResponse } from "../../../../codegen-api";
import RowActionButton from "../../../../components/shared/RowActionButton";
import { DefaultCellForColumn } from "../../../../components/shared/Table/DefaultCellForColumn";
import { DefaultHeaderForColumn } from "../../../../components/shared/Table/DefaultHeaderForColumn";
import {
  Align,
  ButtonGroup,
  GroupedCells,
} from "../../../../components/shared/Table/style";
import { COLORS } from "../../../../constants/design/colors";
import { SPACING } from "../../../../constants/design/spacing";
import { ITableColumn } from "../../../../interfaces/Table/TableColumn";
import { IFormStrategy } from "./types";

interface IUseStrategyColumnsProps {
  strategies: IFormStrategy[];
  onDeleteLeg: (index: number) => void;
  t: TFunction<"app", "pages.RFQPage.CreateRFQ">;
}

export function useStrategyColumns({
  strategies,
  onDeleteLeg,
  t,
}: IUseStrategyColumnsProps) {
  const columns: ITableColumn<IFormStrategy>[] = useMemo(
    () => [
      {
        title: t("asset"),
        id: "asset",
        accessor: "asset",
        Cell: ({ value }) => <Align align="left">{value}</Align>,
      },
      {
        title: t("instrument_type"),
        id: "instrument_type",
        accessor: "instrument_type",
        Cell: ({ value }) => <Align align="left">{value}</Align>,
      },
      {
        title: t("side"),
        id: "side",
        accessor: "side",
        Cell: ({ value }) => (
          <Align
            align="left"
            style={{
              color:
                value === SideResponse.Buy
                  ? COLORS.up.one
                  : COLORS.down.one,
            }}
          >
            {value}
          </Align>
        ),
      },
      {
        title: t("option_type"),
        id: "option_type",
        accessor: "option_type",
        Cell: ({ value }) => <Align align="left">{value}</Align>,
      },
      {
        title: t("expiry"),
        id: "expiry",
        accessor: "expiry",
        Cell: ({ value }) => <Align align="left">{value}</Align>,
      },
      {
        title: t("strike"),
        id: "strike",
        accessor: "strike",
        Cell: ({ value }) => (
          <Align align="left">{currency(value || "").format()}</Align>
        ),
      },
      {
        title: t("ratio"),
        id: "ratio",
        accessor: "ratio",
        Cell: ({ value }) => <Align align="left">{value}</Align>,
      },
      {
        title: t("actions"),
        id: "actions",
        Cell: ({ row }: any) => (
          <Align align="right">
            <GroupedCells>
              <ButtonGroup>
                <RowActionButton
                  variant={"close"}
                  onClick={() => onDeleteLeg(row.index)}
                  style={{ marginRight: `${SPACING.two}px` }}
                />
              </ButtonGroup>
            </GroupedCells>
          </Align>
        ),
      },
    ],
    [onDeleteLeg, t]
  );

  return useTable({
    columns,
    data: strategies,
    defaultColumn: {
      Header: DefaultHeaderForColumn,
      Cell: DefaultCellForColumn,
    } as any,
  });
}
